import * as Sentry from '@sentry/react';
import { router } from './src/providers';

Sentry.init({
  dsn: import.meta.env.PUBLIC_SENTRY_DSN,
  environment: import.meta.env.PUBLIC_SENTRY_ENVIRONMENT,
  integrations: [
    // See docs for support of different versions of variation of tanstack router
    // https://docs.sentry.io/platforms/javascript/guides/react/features/tanstack-router/
    Sentry.tanstackRouterBrowserTracingIntegration(router),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: import.meta.env.DEV ? 0 : 1.0,

  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
